export enum FileOptionTabTitle {
  PORTFOLIO = "Portfolio",
  VOTING_RECORDS = "Voting Records",
  ENGAGEMENT_RECORDS = "Engagement Records",
}

export type FileLocation = {
  bucket: string;
  prefix: string;
  file: string;
};

export type UploadFileRequestParams = {
  file: File;
};

export type RunCalculateCompassMetricsResponse = {
  status: string;
  message: string;
  data?: Record<string, never>;
};
